function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, useRef, useState } from 'react';
import styled, { withTheme } from 'styled-components';
import { Box, Button, Drop, Text } from 'grommet';
import PropTypes from 'prop-types';

// NOTE: drop-shadow not supported in most browsers
const ArrowDown = styled.span`
  position: relative;
  top: ${props => props.theme.global.edgeSize.small};
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: ${props => `10px solid ${props.theme.global.colors[props.background]}`};
  transform: translate(0, 100%);
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
  align-self: center;
`;
const ArrowUp = styled.span`
  position: relative;
  top: ${props => '-' + props.theme.global.edgeSize.small};
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: ${props => `10px solid ${props.theme.global.colors[props.background]}`};
  transform: translate(0, -100%);
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
  align-self: center;
`;
const ArrowRight = styled.span`
  position: relative;
  top: ${props => '-' + props.theme.global.edgeSize.large};
  left: 1.5rem;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: ${props => `10px solid ${props.theme.global.colors[props.background]}`};
  transform: rotate(90deg);
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
  align-self: end;
`;
const Popconfirm = ({
  align,
  background,
  cancelText,
  children,
  okText,
  onCancel: userOnCancel,
  onConfirm: userOnConfirm,
  title,
  theme,
  maxTextWidth,
  margin,
  ...rest
}) => {
  const cancelBtnColor = theme.global.colors['status-critical'];
  const defaultIsVisible = false;
  const [isVisible, setIsVisible] = useState(defaultIsVisible);
  const childRef = useRef();
  const handleConfirmClick = e => {
    userOnConfirm(e);
    setIsVisible(false);
  };
  const handleCancel = () => {
    userOnCancel();
    setIsVisible(false);
  };
  const closePopConfirm = () => {
    setIsVisible(false);
  };
  const getAlignmentObj = () => {
    let alignmentObj = {};
    switch (align) {
      case 'left':
        alignmentObj.right = 'left';
        break;
      case 'right':
        alignmentObj.left = 'right';
        break;
      case 'top':
        alignmentObj.bottom = 'top';
        break;
      case 'bottom':
        alignmentObj.top = 'bottom';
        break;
      case 'center':
        alignmentObj = [{}];
        break;
      default:
        break;
    }
    return alignmentObj;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-block'
    },
    onClick: e => {
      e.stopPropagation();
      setIsVisible(true);
    },
    ref: childRef
  }, Children.only(children)), childRef.current && isVisible && /*#__PURE__*/React.createElement(Drop, {
    align: getAlignmentObj(),
    elevation: "small",
    target: childRef.current,
    overflow: "visible",
    onClickOutside: closePopConfirm,
    plain: true
  }, /*#__PURE__*/React.createElement(Box, _extends({
    flex: {
      shrink: 0
    },
    gap: "xsmall",
    margin: margin,
    pad: "small",
    background: background,
    round: "xsmall"
  }, rest), align === 'bottom' && /*#__PURE__*/React.createElement(ArrowUp, {
    background: background,
    theme: theme
  }), /*#__PURE__*/React.createElement(Box, {
    width: {
      max: maxTextWidth
    }
  }, /*#__PURE__*/React.createElement(Text, null, title)), /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    direction: "row",
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    label: okText,
    onClick: handleConfirmClick,
    color: "brand",
    primary: true
  }), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    label: cancelText,
    onClick: handleCancel,
    primary: true,
    color: cancelBtnColor
  })), align === 'top' && /*#__PURE__*/React.createElement(ArrowDown, {
    background: background,
    theme: theme
  }), align === 'left' && /*#__PURE__*/React.createElement(ArrowRight, {
    background: background,
    theme: theme
  }))));
};
Popconfirm.defaultProps = {
  align: 'top',
  background: 'light-4',
  cancelText: 'No',
  onCancel: () => {},
  okText: 'Yes',
  title: 'Are you sure ?',
  maxTextWidth: 'large',
  margin: 'xsmall'
};
Popconfirm.propTypes = {
  align: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  background: PropTypes.string,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  okText: PropTypes.string,
  title: PropTypes.string
};
export default withTheme(Popconfirm);